import { Label, Input } from 'reactstrap';
import { StatusLearning } from '../../../../../Constant';
import { STATUS_CHECK_DATA } from '../../../../../Data/Learning';

const StatusCheckBox = () => {
  return (
    <div className="checkbox-animated mt-0">
      <div className="learning-header">
        <span className="f-w-600">{StatusLearning}</span>
      </div>
      {STATUS_CHECK_DATA.map((data, index) => (
        <Label key={index} className="d-block" htmlFor={`StatusCheckBox-${index}`} check>
          <Input className="checkbox_animated" id={`StatusCheckBox-${index}`} type="checkbox" />
          {data}
        </Label>
      ))}
    </div>
  );
};

export default StatusCheckBox;
